export function fromDTO(DTO) {
  return {
    date: DTO.date,
    failureCode: DTO.failureCode,
    customFailure: DTO.customFailure
  };
}